import Card from "@mui/material/Card";

import EmptyState from "@/components/Core/EmptyState";
import { useDeviceType } from "@/hooks";

import { NO_DATA_MIN_HEIGHT_DESKTOP, NO_DATA_MIN_HEIGHT_MOBILE } from "./data";

interface NoDataProps {
  minHeight?: string;
}

/**
 * The card an empty list leaves behind.
 *
 * Keeps its own name and its `minHeight` prop - the game grid, the game list
 * and the session table all reach for it - but the inside is the app-wide
 * `EmptyState` now, so a filtered-to-nothing grid says it the same way the
 * bet slip and the notification tray do.
 */
export const NoData = ({ minHeight }: NoDataProps) => {
  const { isMobile } = useDeviceType();
  const height = minHeight || (isMobile ? NO_DATA_MIN_HEIGHT_MOBILE : NO_DATA_MIN_HEIGHT_DESKTOP);

  return (
    <Card sx={{ width: "100%", display: "flex" }}>
      <EmptyState
        title="table.no-records-found"
        description="table.no-records-hint"
        minHeight={height}
      />
    </Card>
  );
};
